(function(){
  function openBodyChart(container){
    var chart=container.querySelector('.id-fit');
    if(!chart || chart.querySelector('details[open]')) return;
    var body=chart.querySelector('.id-fit__details--body');
    if(body) body.open=true;
  }
  function activate(wrap, i){
    var tabs = wrap.querySelectorAll('.ids-tabs__t');
    var panels = wrap.querySelectorAll('.ids-tabs__p');
    var j;
    for(j=0;j<tabs.length;j++){
      var on = (j===i);
      tabs[j].classList.toggle('is-active', on);
      tabs[j].setAttribute('aria-selected', on?'true':'false');
      tabs[j].tabIndex = on?0:-1;
    }
    for(j=0;j<panels.length;j++){
      panels[j].style.display = '';           /* clear any stale inline display */
      panels[j].classList.toggle('is-shown', j===i);
      if(j===i) openBodyChart(panels[j]);
    }
  }

  function bindTabs(wrap){
    if(wrap.__idsTabsBound) return;
    wrap.__idsTabsBound = true;
    var tabs = wrap.querySelectorAll('.ids-tabs__t');
    for(var i=0;i<tabs.length;i++){
      (function(idx){
        tabs[idx].addEventListener('click', function(e){ e.preventDefault(); activate(wrap, idx); });
        tabs[idx].addEventListener('keydown', function(e){
          if(e.key!=='ArrowLeft' && e.key!=='ArrowRight') return;
          e.preventDefault();
          var dir = (e.key==='ArrowLeft') ? 1 : -1;
          var n = (idx + dir + tabs.length) % tabs.length;
          activate(wrap, n); tabs[n].focus();
        });
      })(i);
    }
  }

  /* mobile accordion: opening one closes the others (per group) */
  function initAcc(root){
    var items = root.querySelectorAll('.ids-acc__item');
    for(var i=0;i<items.length;i++){
      (function(el){
        if(el.__idsAccBound) return; el.__idsAccBound = true;
        el.addEventListener('toggle', function(){
          if(!el.open) return;
          openBodyChart(el);
          var sibs = el.parentNode ? el.parentNode.querySelectorAll('.ids-acc__item') : [];
          for(var j=0;j<sibs.length;j++){ if(sibs[j]!==el && sibs[j].open){ sibs[j].open=false; } }
        });
      })(items[i]);
    }
  }

  function boot(){
    var roots = document.querySelectorAll('[data-ids-pdp]');
    for(var i=0;i<roots.length;i++){
      var root = roots[i];
      var d = root.querySelector('.ids-pdp__d');
      if(d){ bindTabs(d); }
      initAcc(root);
    }
  }

  boot();
  if(!window.__idsPdpTabsSectionLoadBound){
    window.__idsPdpTabsSectionLoadBound = true;
    document.addEventListener('shopify:section:load', boot);
  }
})();
